import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ae659ff4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "section-border"
};
const _hoisted_2 = {
  class: "select-title"
};
const _hoisted_3 = {
  class: "section-border"
};
const _hoisted_4 = {
  class: "select-title"
};
const _hoisted_5 = {
  class: "position-right btn-right"
};
const _hoisted_6 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, " 选择Excel文件，或拖拽文件到此区域 ", -1));
const _hoisted_8 = {
  class: "el-upload__tip upload-border"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {
    "color": "#0099ff"
  },
  target: "_blank",
  href: "https://alidocs.dingtalk.com/i/nodes/AY39rGpMPmeVNNO2xZ6RVOZkXKnaoNQ7"
}, " 点击可查看数据校验规则", -1));
const _hoisted_12 = {
  style: {
    "float": "right",
    "margin": "20px 0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_button = _resolveComponent("el-button");
  const _component_base_form = _resolveComponent("base-form");
  const _component_arrow_down = _resolveComponent("arrow-down");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_base_table = _resolveComponent("base-table");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_base_option = _resolveComponent("base-option");
  const _component_base_confirm = _resolveComponent("base-confirm");
  const _component_update_waybill = _resolveComponent("update-waybill");
  const _component_view_waybill = _resolveComponent("view-waybill");
  const _component_el_step = _resolveComponent("el-step");
  const _component_el_steps = _resolveComponent("el-steps");
  const _component_upload_filled = _resolveComponent("upload-filled");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_error_table = _resolveComponent("error-table");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("section", null, [_createElementVNode("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createTextVNode(" 筛选条件 ")]), _createVNode(_component_base_form, {
    properties: _ctx.$global.logisticsChooseOptions,
    "base-form": $data.chooseForm,
    inline: true,
    width: "130px",
    onGetWarehouse: $options.getWarehouse,
    onGetDate: $options.getDate,
    onSearchWaybillNo: $options.searchWaybillNo
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.queryList
    }, {
      default: _withCtx(() => [_createTextVNode(" 查询 ")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      onClick: $options.resetForm
    }, {
      default: _withCtx(() => [_createTextVNode(" 重置 ")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["properties", "base-form", "onGetWarehouse", "onGetDate", "onSearchWaybillNo"])]), _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_divider, {
    direction: "vertical"
  }), _createTextVNode(" 运单列表 ")]), _createVNode(_component_el_tabs, {
    modelValue: $data.activeTab,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.activeTab = $event),
    class: "demo-tabs",
    onTabClick: $options.handleClick
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$global.transitState, tag => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: tag.key,
        label: JSON.stringify($data.transitState) === '{}' ? tag.label : `${tag.label}(${$data.transitState[tag.name]})`,
        name: tag.name
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => $options.showOrderForm('create'))
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增订单信息 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => $options.showOrderForm('update'))
        }, {
          default: _withCtx(() => [_createTextVNode(" 修改订单信息 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: $options.showUpdateLogisticSupplierForm
        }, {
          default: _withCtx(() => [_createTextVNode(" 修改物流商 ")]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          onClick: $options.handleExceptionHandling
        }, {
          default: _withCtx(() => [_createTextVNode(" 异常已处理 ")]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_dropdown, {
          style: {
            "margin": "0 12px"
          },
          onCommand: $options.handleWaybillLabel
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.labelList, item => {
              return _openBlock(), _createBlock(_component_el_dropdown_item, {
                key: item.id,
                command: item.id
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["command"]);
            }), 128))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            style: {
              "width": "80px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" 标记为 "), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_arrow_down)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["onCommand"]), _createVNode(_component_el_button, {
          onClick: $options.showDeleteWaybillDialog
        }, {
          default: _withCtx(() => [_createTextVNode(" 删除 ")]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_dropdown, {
          style: {
            "margin": "0 12px"
          },
          onCommand: $options.handleImport
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: "0"
            }, {
              default: _withCtx(() => [_createTextVNode(" 导入发货运单 ")]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "1"
            }, {
              default: _withCtx(() => [_createTextVNode(" 导入退货运单 ")]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "2"
            }, {
              default: _withCtx(() => [_createTextVNode(" 导入调拨运单 ")]),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            style: {
              "width": "80px"
            },
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(" 导入 "), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_arrow_down)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["onCommand"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.exportWaybill
        }, {
          default: _withCtx(() => [_createTextVNode(" 导出 ")]),
          _: 1
        }, 8, ["onClick"])]), _createVNode(_component_base_table, {
          table: $data.table,
          pagination: $data.pagination,
          total: _ctx.$store.state.logistics.listTotal,
          onChangePagination: $options.changePagination,
          onGetSelectedIds: $options.getSelectedIds,
          onGetDeletedId: $options.getDeletedId
        }, {
          default: _withCtx(slotProps => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            style: {
              "width": "40px"
            },
            onClick: $event => $options.updateWaybill(slotProps.row.id, slotProps.row.parcel_type)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改运单 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "success",
            size: "small",
            style: {
              "width": "40px"
            },
            onClick: $event => $options.viewWaybill(slotProps.row.id, slotProps.row.stay_time)
          }, {
            default: _withCtx(() => [_createTextVNode(" 详情 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["table", "pagination", "total", "onChangePagination", "onGetSelectedIds", "onGetDeletedId"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onTabClick"])])), [[_directive_loading, _ctx.$store.state.logistics.listLoading]]), _createVNode(_component_base_option, {
    modelValue: $data.orderFormVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.orderFormVisible = $event),
    title: $data.orderFormType === 'create' ? '新增订单信息' : '修改订单信息',
    width: "24%",
    onCloseDialog: $options.closeOrderForm
  }, {
    default: _withCtx(() => [_createVNode(_component_base_form, {
      ref: "orderForm",
      properties: $data.orderFormType === 'create' ? _ctx.$global.createOrderFields : _ctx.$global.updateOrderFields,
      "base-form": $data.orderForm,
      inline: false,
      width: "100px",
      "base-rules": _ctx.$global.orderRules,
      onGetInfo: $options.getOrderInfo
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: $options.closeOrderForm
      }, {
        default: _withCtx(() => [_createTextVNode(" 取消 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => $options.submitOrderForm($data.orderFormType))
      }, {
        default: _withCtx(() => [_createTextVNode(" 确定 ")]),
        _: 1
      })]),
      _: 1
    }, 8, ["properties", "base-form", "base-rules", "onGetInfo"])]),
    _: 1
  }, 8, ["modelValue", "title", "onCloseDialog"]), _createVNode(_component_base_option, {
    modelValue: $data.logisticSupplierVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.logisticSupplierVisible = $event),
    title: "修改物流商",
    width: "24%",
    onCloseDialog: $options.closeLogisticSupplierForm
  }, {
    default: _withCtx(() => [_createVNode(_component_base_form, {
      ref: "logisticSupplierForm",
      properties: [{
        label: '新物流商',
        type: 'select',
        multiple: false,
        prop: 'logistic_supplier_id',
        options: [],
        option_type: 'name'
      }],
      "base-form": $data.logisticSupplierForm,
      inline: false,
      width: "100px",
      "base-rules": {
        logistic_supplier_id: [{
          required: true,
          message: '请输入内容'
        }]
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: $options.closeLogisticSupplierForm
      }, {
        default: _withCtx(() => [_createTextVNode(" 取消 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.submitLogisticSupplierForm
      }, {
        default: _withCtx(() => [_createTextVNode(" 确定 ")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 8, ["base-form"])]),
    _: 1
  }, 8, ["modelValue", "onCloseDialog"]), $data.deleteWaybillVisible ? (_openBlock(), _createBlock(_component_base_confirm, {
    key: 0,
    "dialog-visible": $data.deleteWaybillVisible,
    content: "数据会全部清除，是否确认删除?",
    onGetVisible: $options.closeDeleteWaybillDialog,
    onConfirmDeletion: $options.confirmDeletionWaybill
  }, null, 8, ["dialog-visible", "onGetVisible", "onConfirmDeletion"])) : _createCommentVNode("", true), _createVNode(_component_base_option, {
    modelValue: $data.updateWaybillVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.updateWaybillVisible = $event),
    width: "60%"
  }, {
    default: _withCtx(() => [_createVNode(_component_update_waybill, {
      ref: "updateWaybillForm",
      "parcel-type": $data.parcelType,
      form: $data.updateWaybillForm,
      "city-option": $data.cityOption,
      "state-option": $data.stateOption,
      "country-option": $data.countryOption,
      "warehouse-option": $data.warehouseOption
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: $options.closeUpdateWaybillDialog
      }, {
        default: _withCtx(() => [_createTextVNode(" 取消 ")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.submitUpdateWaybillForm
      }, {
        default: _withCtx(() => [_createTextVNode(" 确定 ")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 8, ["parcel-type", "form", "city-option", "state-option", "country-option", "warehouse-option"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_base_option, {
    modelValue: $data.viewWaybillVisible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.viewWaybillVisible = $event),
    width: "70%"
  }, {
    default: _withCtx(() => [_createVNode(_component_view_waybill, {
      form: $data.waybillDetail,
      "stay-time": $data.stayTime
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.asyncWaybillInfo
      }, {
        default: _withCtx(() => [_createTextVNode(" 同步 ")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 8, ["form", "stay-time"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_base_option, {
    modelValue: $data.importWaybillVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.importWaybillVisible = $event),
    title: $data.waybillType == '0' ? '导入发货运单' : $data.waybillType == '1' ? '导入退货运单' : '导入调拨运单',
    width: "40%"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_steps, {
      active: _ctx.$store.state.logistics.stepActive,
      "align-center": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_step, {
        title: "上传Excel"
      }), _createVNode(_component_el_step, {
        title: "数据校验"
      })]),
      _: 1
    }, 8, ["active"])]), _ctx.$store.state.logistics.stepActive === 1 ? (_openBlock(), _createBlock(_component_el_upload, {
      key: 0,
      drag: "",
      action: "",
      "show-file-list": false,
      "http-request": $options.importWaybill
    }, {
      tip: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createTextVNode(" 为保证数据顺利导入，推荐您下载 "), _createElementVNode("a", {
        class: "import-template_btn",
        onClick: _cache[8] || (_cache[8] = (...args) => $options.downloadImportTemplate && $options.downloadImportTemplate(...args))
      }, "导入模板")])]),
      default: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "el-icon--upload"
      }, {
        default: _withCtx(() => [_createVNode(_component_upload_filled)]),
        _: 1
      }), _hoisted_7]),
      _: 1
    }, 8, ["http-request"])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createTextVNode(" 该文档存在" + _toDisplayString($data.error.total) + "条错误数据，请修改后上传。 ", 1), _hoisted_11]), _createVNode(_component_el_scrollbar, {
      height: "200px"
    }, {
      default: _withCtx(() => [_createVNode(_component_error_table, {
        list: $data.error.list
      }, null, 8, ["list"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.backStep
    }, {
      default: _withCtx(() => [_createTextVNode(" 上一步 ")]),
      _: 1
    }, 8, ["onClick"])])]))]),
    _: 1
  }, 8, ["modelValue", "title"])]);
}